import { Grid, Typography, Card, CardContent } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "../../utils/Router";
import * as Yup from "yup";
import { FormProvider, RHFTextField } from "../../common/hook-form";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { apiConstants, postGeneric } from "../../common/constants";
import { useSnackbar } from "notistack";
import { useFormData } from "../../utils/formDataProvider";
import { LoadingButton } from "@mui/lab";

function CustomOrderDetailForm() {
  const { navigate } = useNavigate();
  const phoneRegExp = /^\d{10}$/;
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [queryParams, setQueryParams] = useState({});
  const { setFormData } = useFormData();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const params = {};
    for (let param of searchParams.entries()) {
      params['value'] = param[0];
    }
    setQueryParams(params)
  }, [])

  // useEffect(() => {
  //   if (window.location.origin) {
  //     setConfigLoading(true)
  //     // getGeneric(`${apiConstants.GET_CONFIG_DATA_BY_BRAND}?brandUrl=${window.location.origin}`).then((res) => {
  //     getGeneric(`${apiConstants.GET_CONFIG_DATA_BY_BRAND}?brandUrl=https://palettereturns.proship.in`).then((res) => {
  //       setConfigData(res.data)
  //       setConfigLoading(false)
  //     }).catch((err) => {
  //       setConfigLoading(false)
  //       console.log(err);
  //     })
  //   }
  // }, [window.location.origin])

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        awbNumber: Yup.string().trim().required("This field is required"),
        phoneNumber: Yup.string()
          .matches(phoneRegExp, { message: 'Phone Number must be exactly 10 digits', excludeEmptyString: true })
          .min(10, 'Phone Number must be at least 10 digits')
          .required("Phone Number is required!")
      })
    ),
    defaultValues: {
      awbNumber: queryParams.value,
      phoneNumber: '',
    },
  });


  const { handleSubmit, setValue, watch } = methods;

  useEffect(() => {
    if (queryParams.value) {
      setValue('awbNumber', queryParams.value);
    }
  }, [queryParams, setValue]);

  const onSubmit = (data) => {
    setIsLoading(true)
    const payload = {
      "awbNumber": data.awbNumber,
      "phoneNumber": data.phoneNumber
    }
    postGeneric(`${apiConstants.GENERATE_OTP}`, payload).then((res) => {
      setIsLoading(false)
      if (res.data?.status !== "failed" && res.data?.tokenId) {
        setFormData(data);
        navigate(`/otp`, res.data?.tokenId);
        enqueueSnackbar(res?.data?.message, { variant: 'success' })
      } else {
        enqueueSnackbar(res?.data?.message, { variant: 'error' })
      }
    }).catch((err) => {
      setIsLoading(false)
      console.log(err);
      enqueueSnackbar(err?.response?.data?.message || "Some error occurred!", { variant: 'error' })
    })
  }

  return (
    <Card
      sx={{
        maxWidth: { xs: '100%', sm: 600 },
        margin: 'auto',
        mt: 4,
        boxShadow: 'none',
        p: { xs: 2, sm: 6 },
      }}
    >
      <CardContent>
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sx={{ mb: 2 }}>
              <Typography variant="h6" fontWeight={500} sx={{ color: '#004e32' }}>
                Return/Exchange Order
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <RHFTextField
                placeholder="Enter Order ID / AWB"
                label="Enter Order ID / AWB *"
                name="awbNumber"
                value={watch("awbNumber") || ''}
              />
            </Grid>
            <Grid item xs={12}>
              <RHFTextField
                placeholder="e.g. 8967676767"
                label="Enter Mobile Number *"
                name="phoneNumber"
              />
            </Grid>
            <Grid item xs={12}>
              <LoadingButton
                loading={isLoading}
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                disableElevation
                sx={{ borderRadius: 10, backgroundColor: '#00A587' }}
              >
                Login
              </LoadingButton>
            </Grid>
          </Grid>
        </FormProvider>
      </CardContent>
    </Card>
  );
}

export default CustomOrderDetailForm;
